import { render, staticRenderFns } from "./otherOption.vue?vue&type=template&id=d4f1d666&"
import script from "./otherOption.vue?vue&type=script&lang=js&"
export * from "./otherOption.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "otherOption.vue"
export default component.exports